import { GetUserTestTagData } from '../ManualRewards/types'
import { Tag } from '../Tags/types'

export const calculateUserTestByTags = (userTestTagData: GetUserTestTagData[], tags: Tag[]) => {
  let sum = 0

  if (!tags.length) {
    userTestTagData.forEach(element => {
      sum += element.count
    })
    return sum
  }

  userTestTagData.forEach(element => {
    sum += tags.find(tag => tag.id === element.tagId) ? element.count : 0
  })
  return sum
}
